<template>
  <div class="card-form">
    <div class="d-flex mb-2">
      <div class="side-frame-success"></div>
      <div>
        <span style="font-size: 14px; color: #606266">
          NO：{{ flipOrderForm.amzFlipOrderNo }}
        </span>
        <el-divider direction="vertical"> </el-divider>
        <b-badge class="mr-2" style="font-size: 12px" variant="info">
          {{ flipOrderForm.v_skuSalesChannel }}
        </b-badge>
        <el-divider direction="vertical"></el-divider>
        <b-badge
          class="mr-2"
          style="font-size: 12px"
          :variant="
            flipOrderForm.amzFlipOrderStatus == 'N'
              ? 'info'
              : flipOrderForm.amzFlipOrderStatus == 'S'
              ? 'primary'
              : flipOrderForm.amzFlipOrderStatus == 'P'
              ? 'success'
              : flipOrderForm.amzFlipOrderStatus == 'R'
              ? 'danger'
              : flipOrderForm.amzFlipOrderStatus == 'D'
              ? 'danger'
              : flipOrderForm.amzFlipOrderStatus == 'T'
              ? 'primary'
              : flipOrderForm.amzFlipOrderStatus == 'A'
              ? 'success'
              : flipOrderForm.amzFlipOrderStatus == 'B'
              ? 'danger'
              : ''
          "
        >
          {{ flipOrderForm.v_amzFlipOrderStatus || '草稿' }}
        </b-badge>
        <el-divider direction="vertical"></el-divider>
        <span style="font-size: 14px; color: #606266">
          Modify：{{
            flipOrderForm.modifyByName ? flipOrderForm.modifyByName : '--'
          }}
          at
          {{ flipOrderForm.modifyTime ? flipOrderForm.modifyTime : '--' }}
        </span>
      </div>
    </div>
    <div
      style="    font-size: 15px;
    color: rgb(96, 98, 102);
    font-weight: 600;"
      class="mt-2 mb-2"
    >
      {{ flipOrderForm.title }}
    </div>
    <page-main
      :tableData="tableData"
      :loading="loading"
      :disabled="disabled"
      :tablePage="page"
      @reload="reload"
      @edit="edit"
      @confirmOrder="confirmOrder"
      @review="review"
      @choose-change="(e) => (checkedRows = e)"
    >
      <div slot="toolbar" class="table_toolbar">
        <div class="d-flex">
          <SearchTabs
            v-model="orderSkuStatus"
            :options="searchTabOpts"
            @change="reload"
          />
          <b-button
            size="sm"
            class="ml-2"
            variant="outline-primary"
            @click="reviewVisible = true"
            v-if="allow('C')"
          >
            {{ $l('btn_moq_confirm') || 'MOQ确认' }}
          </b-button>
          <b-button
            size="sm"
            class="ml-2"
            variant="outline-primary"
            @click="appendSpu"
            v-if="allow('F') && !disabled"
          >
            {{ $l('btn_add_spu') || '追加SPU' }}
          </b-button>
          <b-button
            size="sm"
            class="ml-2"
            variant="outline-primary"
            @click="openDeleteSpu"
            v-if="allow('G') && !disabled"
          >
            {{ $l('btn_delete_spu') || '移除SPU' }}
          </b-button>
          <b-button
            :disabled="!checkedReviewCount"
            size="sm"
            class="ml-2"
            variant="outline-primary"
            @click="reviewCheck"
            v-if="allow('O') && !disabled"
          >
            {{ $l('btn_submit_review') || '提交审核' }}
          </b-button>
        </div>
        <div class="toolbar_tools" @click="advqueryDialogVisible = true">
          <vxe-button circle>
            <i class="vxe-icon--search" />
          </vxe-button>
        </div>
      </div>

      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </page-main>
    <Review
      v-if="reviewVisible"
      :visible.sync="reviewVisible"
      :amzFlipOrderCode="amzFlipOrderCode"
      @close="reviewVisible = false"
      :disabled="disabled"
    ></Review>
    <PageHeader
      :advqueryDialogVisible="advqueryDialogVisible"
      ref="header"
      @query="getData"
      @reset="resetPage"
      @close="advqueryDialogVisible = false"
    ></PageHeader>
    <EditSku
      @reload="reload"
      :amzFlipOrderSkuCode="editSkuOption.amzFlipOrderSkuCode"
      v-if="editSkuOption.visible"
      :visible.sync="editSkuOption.visible"
      @close="editSkuOption.visible = false"
    ></EditSku>
    <el-dialog
      :title="$l('dialog_add_spu') || '追加SPU'"
      :visible.sync="addSpuOption.visible"
      v-if="addSpuOption.visible"
      width="1200px"
      top="10px"
      :show-close="true"
      :before-close="closeAddSpu"
      :close-on-click-modal="false"
      v-el-dialog-drag
    >
      <ChooseAmzSpu
        ref="chooseAmzSpu"
        :orderType="flipOrderForm.skuSalesChannel"
        @close="closeAddSpu"
        @save="saveSpu"
        @checkboxChange="(data) => (checkboxChange = data)"
      ></ChooseAmzSpu>
    </el-dialog>
    <el-dialog
      :title="$l('dialog_title_delete_spu') || '移除SPU'"
      :visible.sync="deleteSpuOption.visible"
      v-if="deleteSpuOption.visible"
      width="1200px"
      top="10px"
      :show-close="true"
      :before-close="closeDeleteSpu"
      :close-on-click-modal="false"
      v-el-dialog-drag
    >
      <DeleteAmzSpu
        ref="deleteAmzSpu"
        :amzFlipOrderCode="amzFlipOrderCode"
        @close="closeDeleteSpu"
        @save="deleteSpu"
        @checkboxChange="(data) => (checkboxChange = data)"
      ></DeleteAmzSpu>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import PageMain from './main.vue'
import PageHeader from './header'
import BaseTable from '@/mixins/base-table'
import SearchTabs from './search-tabs'
import Review from '../review'
import EditSku from '../edit-sku'
import ChooseAmzSpu from '../choose-amz-spu'
import DeleteAmzSpu from '../delete-amz-spu'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [BaseTable, EditLoading],
  components: {
    PageMain,
    PageHeader,
    SearchTabs,
    Review,
    EditSku,
    ChooseAmzSpu,
    DeleteAmzSpu,
  },
  props: {
    amzFlipOrderCode: { type: String, default: '' },
    skuSalesChannel: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      usePage: true,
      reviewVisible: false,
      advqueryDialogVisible: false,
      editSkuOption: {
        visible: false,
        amzFlipOrderSkuCode: '',
      },
      deleteSpuOption: {
        visible: false,
      },
      flipOrderForm: {
        spuNoList: [],
        title: '',
        skuSalesChannel: '',
      },
      spuNoListBak: [],
      addSpuOption: {
        visible: false,
      },
      table: [],
      checkedRows: [],
      orderSkuStatus: '',
      rejected: 0,
      confirm: 0,
      reviewCount: 0,
      passed: 0,
      draft: 0,
    }
  },
  computed: {
    ...mapState('admin/user', ['info']),
    searchTabOpts() {
      return [
        {
          label: '审核通过',
          value: 'P',
          badge: this.passed,
        },
        {
          label: '提交审核',
          value: 'S',
          badge: this.reviewCount,
        },
        {
          label: '审核驳回',
          value: 'R',
          badge: this.rejected,
        },
        // {
        //   label: '确认翻单',
        //   value: 'C',
        //   badge: this.confirm,
        // },
        {
          label: '草稿',
          value: 'N',
          badge: this.draft,
        },
        {
          label: '全部',
          value: '',
          badge:
            this.rejected +
            this.confirm +
            this.passed +
            this.reviewCount +
            this.draft,
        },
      ]
    },
    checkedRowCount() {
      return this.checkedRows?.length || 0
    },
    checkedConfirmOrderCount() {
      return (this.checkedRows || []).filter(
        (e) => e.amzFlipOrderSkuStatus == 'N'
      ).length
    },
    checkedReviewCount() {
      return (this.checkedRows || []).filter(
        (e) =>
          e.amzFlipOrderSkuStatus == 'C' ||
          e.amzFlipOrderSkuStatus == 'R' ||
          e.amzFlipOrderSkuStatus == 'N'
      ).length
    },
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      if (this.amzFlipOrderCode) {
        this.$api
          .ecomAmzFlipOrderDetailApi({
            amzFlipOrderCode: this.amzFlipOrderCode,
          })
          .then((res) => {
            this.flipOrderForm = { ...res.body }
            this.spuNoListBak = Object.assign(
              [],
              this.flipOrderForm.spuNoList || []
            )
          })
      }
    },
    getData(form) {
      this.loading = true
      this.checkedRows = []
      let params = {}
      if (this.orderSkuStatus) {
        params['amzFlipOrderSkuStatusList'] = [this.orderSkuStatus]
      }
      this.$api
        .ecomAmzFlipOrderSkuListApi({
          ...form,
          ...this.page,
          ...params,
          amzFlipOrderCode: this.amzFlipOrderCode,
        })
        .then((res) => {
          this.loading = false
          const tmpData = res.body.data || []
          const pageSize = res.body.pageSize
          const curPage = res.body.curPage
          let start = (curPage - 1) * pageSize
          const tableData = []
          let amzFlipOrderSkuCode = ''
          for (let i = 0; i < tmpData.length; i++) {
            const orderInfo = tmpData[i]
            orderInfo.seq = start + i + 1
            const orderMarketInfo = orderInfo.marketInfos || [{ ...orderInfo }]
            orderMarketInfo.map((e) => {
              if (amzFlipOrderSkuCode != orderInfo.amzFlipOrderSkuCode) {
                amzFlipOrderSkuCode = orderInfo.amzFlipOrderSkuCode
                orderInfo['rowspan'] = orderMarketInfo.length
              } else {
                orderInfo['rowspan'] = 0
              }
              tableData.push({ ...e, ...orderInfo })
            })
          }
          res.body.data = tableData
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
      // 统计数据查询
      this.getCount({ ...form, amzFlipOrderSkuStatusList: ['R'] }).then(
        (count) => {
          this.rejected = count
        }
      )
      // this.getCount({ ...form, amzFlipOrderSkuStatusList: ['C'] }).then(
      //   (count) => {
      //     this.confirm = count
      //   }
      // )
      this.getCount({ ...form, amzFlipOrderSkuStatusList: ['S'] }).then(
        (count) => {
          this.reviewCount = count
        }
      )
      this.getCount({ ...form, amzFlipOrderSkuStatusList: ['P'] }).then(
        (count) => {
          this.passed = count
        }
      )
      this.getCount({ ...form, amzFlipOrderSkuStatusList: ['N'] }).then(
        (count) => {
          this.draft = count
        }
      )
    },
    async getCount(params = {}) {
      const res = await this.$api
        .ecomAmzFlipOrderSkuCountApi({
          ...params,
          amzFlipOrderCode: this.amzFlipOrderCode,
        })
        .catch(() => null)
      if (!res) return 0
      return res.body || 0
    },
    appendSpu() {
      this.addSpuOption.visible = true
    },
    closeAddSpu() {
      this.addSpuOption.visible = false
    },
    closeDeleteSpu() {
      this.deleteSpuOption.visible = false
    },
    saveSpu() {
      if (this.loadingOpen()) return
      const spuList = this.$refs.chooseAmzSpu.getCheckedRow() || []
      const spuCodeList = spuList.map((e) => e.amzSpuCode)
      this.$api
        .ecomAmzFlipOrderAppendSpuApi({
          amzFlipOrderCode: this.amzFlipOrderCode,
          spuCodeList,
        })
        .then(() => {
          this.loadingClose()
          this.closeAddSpu()
          this.reload()
          this.init()
        })
        .catch(() => {
          this.loadingClose()
        })
    },
    confirmOrderCheck() {
      const amzFlipOrderSkuCodes = this.checkedRows
        .filter((e) => e.amzFlipOrderSkuStatus == 'N')
        .map((e) => e.amzFlipOrderSkuCode)
      this.confirmOrder({ amzFlipOrderSkuCodes })
    },
    reviewCheck() {
      const amzFlipOrderSkuCodes = this.checkedRows
        .filter(
          (e) =>
            e.amzFlipOrderSkuStatus == 'C' ||
            e.amzFlipOrderSkuStatus == 'R' ||
            e.amzFlipOrderSkuStatus == 'N'
        )
        .map((e) => e.amzFlipOrderSkuCode)
      this.review({ amzFlipOrderSkuCodes })
    },
    edit({ amzFlipOrderSkuCode }) {
      this.editSkuOption.visible = true
      this.editSkuOption.amzFlipOrderSkuCode = amzFlipOrderSkuCode
    },
    review({ amzFlipOrderSkuCodes }) {
      this.$confirm(
        this.$l('tips_review') || '是否要提交审核？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      ).then(() => {
        if (this.loadingOpen()) return
        this.$api
          .ecomAmzFlipOrderSkuReviewApi({
            amzFlipOrderSkuCodes,
          })
          .then((res) => {
            this.loadingClose()
            const { status } = res
            if (status == 200) {
              this.$message({
                showClose: true,
                message: this.$l('tips_review_success') || '提交成功',
                type: 'success',
              })
            }
            this.reload()
          })
          .catch(() => {
            this.loadingClose()
          })
      })
    },
    confirmOrder({ amzFlipOrderSkuCodes }) {
      this.$confirm(
        this.$l('tips_confirm_order') || '是否要提交翻单确认？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      ).then(() => {
        if (this.loadingOpen()) return
        this.$api
          .ecomAmzFlipOrderSkuConfirmOrderApi({
            amzFlipOrderSkuCodes,
          })
          .then((res) => {
            this.loadingClose()
            const { status } = res
            if (status == 200) {
              this.$message({
                showClose: true,
                message: this.$l('tips_review_success') || '提交成功',
                type: 'success',
              })
            }
            this.reload()
          })
          .catch(() => {
            this.loadingClose()
          })
      })
    },
    openDeleteSpu() {
      this.deleteSpuOption.visible = true
    },
    deleteSpu() {
      const spuList = this.$refs.deleteAmzSpu.getCheckedRow() || []
      const spuNos = spuList.map((e) => e.amzSpuNo).join(',')
      const spuCodeList = spuList.map((e) => e.amzSpuCode)
      this.$confirm(
        `是否移除SPU[ ${spuNos} ]移除后对应的SKU将会被删除!`,
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          distinguishCancelAndClose: true,
          confirmButtonText: this.$l('INDEX.btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
        }
      )
        .then(() => {
          if (this.loadingOpen()) return
          this.$api
            .ecomAmzFlipOrderDelSpuApi({
              amzFlipOrderCode: this.amzFlipOrderCode,
              spuCodes: spuCodeList,
            })
            .then(() => {
              this.loadingClose()
              this.closeDeleteSpu()
              this.reload()
              this.init()
            })
            .catch(() => {
              this.closeDeleteSpu()
              this.loadingClose()
            })
        })
        .catch(() => {})
    },
  },
}
</script>
<style lang="scss" scoped>
.table_toolbar {
  display: flex;
  justify-content: space-between;
  .search-form {
    width: 100%;
  }
  .search-container {
    margin-right: 10px;
  }
  .toolbar_tools {
    display: flex;
    align-items: center;
    margin-right: 12px;
    .vxe-button--content {
      i {
        font-size: 13px;
      }
    }
  }
}
.side-frame-success {
  padding: 1px 5px;
  border-left: 3px solid $color-success;
  height: 20px;
  margin-top: 3px;
}
.tag-wrapper {
  border: 1px solid #e8e8e8;
  min-height: 50px;
  width: fit-content;
  padding: 5px;
  border-radius: 5px;
}
</style>
